import React, { useState, useEffect, useMemo, useContext } from 'react';
import DatePicker from 'react-datepicker';
import { getProjects } from '../../../services/private/company.service';

import { toast } from 'react-toastify';
import { Form } from 'react-bootstrap';

import { getAllCities } from '../../../services/public/public.service';
import { getLeadsFilter } from '../../../services/private/leads.service';
import SliderModal from '../../../components/Modals/SliderModal';
import CheckAccordion from '../../../components/Modals/FilterModal/Check.accordion';
import DynamicAccordion from '../../../components/Modals/FilterModal/Dynamic.accordion';
import RadioCheckAccordion from '../../../components/Modals/FilterModal/Radio.accordion';
import moment from 'moment';
// import { brokerProjectListing, getAssignedCPs } from '../../../services/private/borker.service';

const EXPIRY_DATE_RANGE = [
    {
        label: 'Expiring in 2-5 days',
        value: 2,
        max_value: 5
    },
    {
        label: 'Expiring in 5-10 days',
        value: 5,
        max_value: 10
    },
    {
        label: 'Expiring in 15-30 days',
        value: 15,
        max_value: 30
    },
    {
        label: 'Expiring in 30-90 days',
        value: 30,
        max_value: 90
    }
]

export default function PlusFilterModal({
    show,
    setShow,
    setFiltersData,
    filterData,
    setFilterCount,
    filtersData,
    filterToaster,
    setCurrentPage,
    projects,
    users
}) {

    // Filter Values            
    const [filterSelected, setFilterSelected] = useState(false)
    const [project, setProject] = useState([]);
    const [brokerCompany, setBrokerCompany] = useState([]);
    const [projectList, setProjectList] = useState([]);
    const [bookingDate, setBookingDate] = useState({});
    const [tokenDate, setTokenDate] = useState({});
    const [svDate, setSvDate] = useState({});
    const [tagging, setTagging] = useState([]);
    const [tagExpiry, setTagExpiry] = useState([]);
    const [member, setMember] = useState([])

    const [inputValues, setInputValues] = useState({
        City: '',
        'RM List': '',
        'Marked By': '',
        'CP Firm': '',
        'Lead Created By': '',
        'Completed By': ''
    });

    const [inputValuesNotFound, setInputValuesNotFound] = useState({
        City: '',
        'RM List': '',
        'Marked By': '',
        'CP Firm': '',
        'Lead Created By': '',
        'Completed By': ''

    });

    const [searchResults, setSearchResults] = useState({
        City: [],
        'RM List': [],
        'Marked By': [],
        'CP Firm': [],
        'Lead Created By': [],
        'Completed By': []
    });

    const [searchDefultResults, setSearchDefaultResults] = useState({
        'RM List': [],
        'Marked By': [],
        'CP Firm': [],
        'Lead Created By': [],
        'Completed By': []
    });

    const ROLE_NAME = localStorage.getItem('role');

    const getAllProjects = async () => {

        await getProjects({}, '').then((res) => {
            if (res.status === 200) {
                let projects = res.data.data.map(i => ({ label: i.name, value: i.id, id: i.id }));
                setProjectList(projects)
            }
        }).catch((err) => {
            console.log("Something went wrong", err);
        })
    }


    const handleSvDateChange = (name, date) => {
        setSvDate({ ...svDate, [name]: date });
    }

    const handleTokenDateChange = (name, date) => {
        setTokenDate({ ...tokenDate, [name]: date });
    }
    const handleBookingDateChange = (name, date) => {
        setBookingDate({ ...bookingDate, [name]: date })
    }
    const getFilterData = async (type, value) => {
        // const res = await getPlusAppFilterUsers({ filterType: type, value: value });
        const res = await getLeadsFilter({ filterType: type, value: value });
        if (res.status === 200) {
            return res.data.data.map(i => ({ ...i, id: i.user_id }))
        }
        else {
            return []
        }
    }

    // const getDefaultUser = async () => {
    //     const res = await getMyUsers();
    //     if (res.data.status === 200) {
    //         const defaultUser = res.data.data.map(u => ({ ...u, value: u.name, user_id: u.id }))
    //         setSearchResults((prevState) => ({
    //             ...prevState,
    //             'Marked By': [...defaultUser],
    //             'RM List': [...defaultUser],
    //             'Lead Created By': [...defaultUser],
    //             'Completed By': [...defaultUser]
    //         }));

    //         setSearchDefaultResults((prevState) => ({
    //             ...prevState,
    //             'Marked By': [...defaultUser],
    //             'RM List': [...defaultUser],
    //             'Lead Created By': [...defaultUser],
    //             'Completed By': [...defaultUser]
    //         }))
    //         getBrokerCompany();
    //     }
    // }

    // const getBrokerCompany = async () => {
    //     await getAssignedCPs('')
    //         .then((res) => {
    //             if (res.data.status === 200) {
    //                 const companies = res.data?.data
    //                     .filter((company) => company.name)
    //                     .map(company => {
    //                         return {
    //                             ...company,
    //                             value: company.name,
    //                         }
    //                     });
    //                 setSearchResults((prevState) => ({
    //                     ...prevState,
    //                     'CP Firm': [...companies],
    //                 }))

    //                 setSearchDefaultResults((prevState) => ({
    //                     ...prevState,
    //                     'CP Firm': [...companies],
    //                 }))
    //             }
    //         })
    //         .catch((err) => {
    //             console.log(err);
    //         })
    // }

    const getAllCitiesByName = async (searchText) => {
        const res = await getAllCities(searchText)

        if (res.data.status === 200) {
            const cities = res.data?.data.map((city) => { return { label: city.name, value: city.name } });
            return cities
        } else {
            return []
        }
    }

    useEffect(() => {
        // getDefaultUser();
        // getBrokerCompany();
        getAllProjects();
    }, []);

    // const handleInputChange = async (e) => {
    //     const inputValuesData = { ...inputValues, [e.target.name]: e.target.value }
    //     setInputValues(inputValuesData);
    //     // setFilterSelected(true)
    //     //if user make input field blank using backspace
    //     if (searchFilterkey.includes(e.target.name) && !e.target.value) {
    //         setSearchResults({ ...searchResults, [e.target.name]: searchDefultResults[e.target.name] });
    //         return false
    //     }

    //     const fieldName = e.target.name;
    //     if (inputValuesData[fieldName].length < 3) {
    //         setSearchResults({ ...searchResults, [fieldName]: [] });
    //         return false
    //     };
    //     let filterData = [];
    //     if (fieldName === 'City') {
    //         filterData = await getAllCitiesByName(inputValuesData[fieldName])
    //     } else if (fieldName === 'CP Firm') {
    //         filterData = await getCompanyName(inputValues[fieldName]);
    //     } else {
    //         filterData = await getFilterData(searchFilterkey.includes(fieldName) ? 'Assign To' : fieldName, inputValuesData[fieldName])
    //     }

    //     if (!filterData?.length) {
    //         setInputValuesNotFound({ ...inputValuesNotFound, [fieldName]: 'No result found.' })
    //     } else {
    //         setInputValuesNotFound({ ...inputValuesNotFound, [fieldName]: '' })
    //     }

    //     setSearchResults({ ...searchResults, [fieldName]: filterData });
    // }

    // const getCompanyName = async (searchText) => {
    //     return getAssignedCPs(searchText)
    //         .then((res) => {
    //             if (res.data.status === 200) {
    //                 const companies = res.data?.data
    //                     .filter((company) => company.name)
    //                     .map(company => {
    //                         return {
    //                             ...company,
    //                             value: company.name,
    //                             id: company.id
    //                         }
    //                     });
    //                 return companies;
    //             }
    //         })
    //         .catch((err) => {
    //             console.log(err);
    //         })
    // }
    useEffect(() => {
        if (project.length || Object.keys(svDate).length || Object.keys(bookingDate).length || Object.keys(tokenDate).length || tagging.length || tagExpiry.length || member.length) {
            setFilterSelected(true)
        } else {
            setFilterSelected(false)
        }
    }, [project, svDate, bookingDate, tokenDate, tagging, tagExpiry, member])

    const getExpiryDate = (date) => {
        return {
            from: moment().add(date.value, 'd').format("YYYY-MM-DD"),
            to: moment().add(date.max_value, 'd').format('YYYY-MM-DD')
        }
    }
    const sendFilterRequest = () => {
        let filterArr = {};

        if (project.length > 0) {
            filterArr['projects'] = [...project]
        }

        if (member.length > 0) {
            filterArr['assigned_to'] = [...member]
        }

        if (Object.keys(svDate).length > 0) {
            let startDate = svDate.startDate;
            let endDate = svDate.endDate || svDate.startDate;
            filterArr['sv_date'] = {
                'from': startDate,
                'to': endDate
            }
        }

        if (Object.keys(tokenDate).length > 0) {
            let startDate = tokenDate.startDate;
            let endDate = tokenDate.endDate || tokenDate.startDate;
            filterArr['token_date'] = {
                'from': startDate,
                'to': endDate
            }
        }

        if (Object.keys(bookingDate).length > 0) {
            let startDate = bookingDate.startDate;
            let endDate = bookingDate.endDate || bookingDate.startDate;
            filterArr['booking_date'] = {
                'from': startDate,
                'to': endDate
            }
        }

        if (tagExpiry.length > 0) {
            const expiryDates = tagExpiry.map(item => getExpiryDate(item));
            localStorage.setItem('plus_tagExpiry', JSON.stringify(tagExpiry))
            filterArr['expiry_period'] = expiryDates
        }


        if (tagging.length) {
            filterArr['tagging_status'] = tagging[0].value
        }


        setFiltersData(filterArr);
        // localStorage.setItem('filter', JSON.stringify(filterArr))                
        setShow(false)
    }

    const handelRemoveClick = () => {
        if (filterSelected || Object.keys(filtersData).length > 0 || project.length > 0 || Object.keys(svDate).length > 0 || Object.keys(tokenDate).length > 0 || Object.keys(bookingDate).length > 0 || tagging.length || tagExpiry.length || member.length) {
            toast.success("All filters Removed");
            // setFilterCount(0);
            setFiltersData({});
            // setCurrentPage(1)
            setBookingDate({})
            setProject([]);
            setTokenDate({});
            setSvDate({})
            setTagging([]);
            setTagExpiry([]);
            setMember([]);
        }
    }

    /***
     * update filter value after refresh if filter applied
     */
    const updateFilterValaue = () => {
        let filters = filtersData;
        let filtersArr = { ...filtersData };
        // for (const filterData of filters) {
        //     filtersArr = { ...filtersArr, ...filterData }
        // }

        let filterKeys = Object.keys(filtersArr);


        if (filterKeys.includes("project")) {
            setProject(filtersArr['project'])
        }
        if (filterKeys.includes('assigned_to')) {
            setMember(filtersArr['assigned_to'])
        }
        if (filterKeys.includes('tagging_status')) {
            if (filtersArr['tagging_status']) {
                setTagging([
                    {
                        label: 'Tagged',
                        value: true
                    }
                ])
            } else {
                setTagging([
                    {
                        label: 'Untagged',
                        value: false
                    }
                ])
            }
            // filterArr['tagging_status'] = tagging[0].value
        }

        if (filterKeys.includes("sv_date")) {
            const { from, to } = filtersArr.sv_date
            const date = {
                'startDate': from,
                'endDate': to,
            }
            setSvDate(date || {})
        }


        if (filterKeys.includes("token_date")) {
            const { from, to } = filtersArr.token_date
            const date = {
                'startDate': from,
                'endDate': to,
            }
            setTokenDate(date || {})
        }

        if (filterKeys.includes("booking_date")) {
            const { from, to } = filtersArr.booking_date
            const date = {
                'startDate': from,
                'endDate': to,
            }
            setBookingDate(date || {})
        }
        if (filterKeys.includes('expiry_period')) {
            const expiryFilter = JSON.parse(localStorage.getItem('plus_tagExpiry'))
            setTagExpiry(expiryFilter)
        }
    }


    useEffect(() => {
        updateFilterValaue();
    }, [
        filtersData,
        show,
    ])

    useEffect(() => {
        // let filters = filtersData;
        const filtersArr = Object.keys(filtersData);
        // for (const filterData of filters) {
        //     filtersArr.push(Object.keys(filterData)[0])
        // }

        if (!filtersArr.includes("project")) {
            setProject([])
        }
        if (!filtersArr.includes('assigned_to')) {
            setMember([]);
        }
        if (!filtersArr.includes("sv_date")) {
            setSvDate({})
        }
        if (!filtersArr.includes('tagging_status')) {
            setTagging([])
        }

        if (!filtersArr.includes("token_date")) {
            setTokenDate({})
        }
        if (!filtersArr.includes("booking_date")) {
            setBookingDate({})
        }
        if (!filtersArr.includes("expiry_period")) {
            setTagExpiry([])
        }
        // setFilterCount(filtersArr.length);
    }, [filtersData])

    return (
        <SliderModal
            show={show}
            setShow={setShow}
            title={'Filters'}
            titleRight={<>
                {filterSelected || Object.keys(filtersData)?.length > 0 ?
                    <a className="fz14 h-font mr-24 black-dark-700 fw-po-medium pr-hover" onClick={handelRemoveClick}>Remove all</a>
                    : " "}
            </>
            }
            body={
                <>
                    <div className="filter">
                        <div className='w-full'></div>
                        <div className="all-fliters">
                            <div id="accordion">


                                {/* <CheckAccordion
                                    value={subscription}
                                    setValue={setSubscription}
                                    selectionValues={SUBSCRIPTION_TYPE}
                                    accordionName="Subscription"
                                    label="Subscription"
                                    showSearch={false}
                                /> */}
                                {projectList.length > 0 && <CheckAccordion
                                    value={project}
                                    setValue={setProject}
                                    selectionValues={projectList}
                                    accordionName="Project"
                                    label="Project"
                                />}

                                {users.length > 0 && <CheckAccordion
                                    value={member}
                                    setValue={setMember}
                                    selectionValues={users}
                                    accordionName="team_member"
                                    label="Team Member"
                                    showSearch={true}
                                />}

                                {/* <CheckAccordion
                                    value={source}
                                    setValue={setSource}
                                    selectionValues={SVTrackerLeadSource}
                                    accordionName="source"
                                    label="Source"
                                /> */}

                                <RadioCheckAccordion
                                    value={tagging}
                                    setValue={setTagging}
                                    selectionValues={[
                                        {
                                            label: 'Tagged',
                                            value: true
                                        },
                                        {
                                            label: 'Untagged',
                                            value: false
                                        }
                                    ]}
                                    accordionName="tagging_status"
                                    label="Tagging Status"
                                    showSearch={false}
                                />

                                <CheckAccordion
                                    value={tagExpiry}
                                    setValue={setTagExpiry}
                                    selectionValues={EXPIRY_DATE_RANGE}
                                    accordionName="tagging_expiry"
                                    label="Tagging Expiry"
                                    showSearch={false}
                                />

                                <div className="filter-card cursor-pointer">
                                    <div className="filter-header collapsed" data-toggle="collapse" data-target="#svDate" aria-expanded="false" aria-controls="svDate" id="headingSv">
                                        <div className="d-flex flex-row align-items-center justify-content-between">
                                            <h2 className="fz16 black mb-0 fw-regular">
                                                SV Date
                                                {Object.keys(svDate).length > 0 && <span>{Object.keys(svDate).length}</span>}
                                            </h2>
                                            <div className="icon mr-0"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                <path fillRule="evenodd" clipRule="evenodd" d="M12 13.5858L16.2929 9.29289C16.6834 8.90237 17.3166 8.90237 17.7071 9.29289C18.0976 9.68342 18.0976 10.3166 17.7071 10.7071L12.7071 15.7071C12.3166 16.0976 11.6834 16.0976 11.2929 15.7071L6.29289 10.7071C5.90237 10.3166 5.90237 9.68342 6.29289 9.29289C6.68342 8.90237 7.31658 8.90237 7.70711 9.29289L12 13.5858Z" fill="#92929D" />
                                            </svg></div>
                                        </div>
                                    </div>
                                    <div id="svDate" className="filter-body collapse" aria-labelledby="headingSv" data-parent="#accordion">
                                        <button className={`border-0 bg-tr mx-3 clear-btn px-0 ${svDate?.startDate ? "" : 'd-none'} `} onClick={() => {
                                            setSvDate({})
                                        }}
                                        >
                                            Clear All
                                        </button>
                                        <div className="d-flex justify-content-between align-center mx-3" >
                                            <div className='mr-8 mb-20 w-100'>
                                                <Form.Label>
                                                    Start Date
                                                </Form.Label>
                                                <DatePicker
                                                    selected={svDate.startDate ? new Date(svDate.startDate) : ''}
                                                    placeholderText={'Start Date'}
                                                    maxDate={new Date()}
                                                    onChange={(date) => handleSvDateChange('startDate', date)}
                                                    dateFormat="dd MMM yyyy"
                                                    className={`form-control text-input`}
                                                />
                                            </div>
                                            <div className='w-100'>
                                                <Form.Label>
                                                    End Date
                                                </Form.Label>
                                                <DatePicker
                                                    selected={svDate.endDate ? new Date(svDate.endDate) : ''}
                                                    placeholderText={'End Date'}
                                                    // maxDate={new Date()}
                                                    minDate={svDate.startDate}
                                                    onChange={(date) => handleSvDateChange('endDate', date)}
                                                    dateFormat="dd MMM yyyy"
                                                    className={`form-control text-input`}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="filter-card cursor-pointer">
                                    <div className="filter-header collapsed" data-toggle="collapse" data-target="#tokenDate" aria-expanded="false" aria-controls="tokenDate" id="headingToken">
                                        <div className="d-flex flex-row align-items-center justify-content-between">
                                            <h2 className="fz16 black mb-0 fw-regular">
                                                Token Date
                                                {Object.keys(tokenDate).length > 0 && <span>{Object.keys(tokenDate).length}</span>}
                                            </h2>
                                            <div className="icon mr-0"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                <path fillRule="evenodd" clipRule="evenodd" d="M12 13.5858L16.2929 9.29289C16.6834 8.90237 17.3166 8.90237 17.7071 9.29289C18.0976 9.68342 18.0976 10.3166 17.7071 10.7071L12.7071 15.7071C12.3166 16.0976 11.6834 16.0976 11.2929 15.7071L6.29289 10.7071C5.90237 10.3166 5.90237 9.68342 6.29289 9.29289C6.68342 8.90237 7.31658 8.90237 7.70711 9.29289L12 13.5858Z" fill="#92929D" />
                                            </svg></div>
                                        </div>
                                    </div>
                                    <div id="tokenDate" className="filter-body collapse" aria-labelledby="headingToken" data-parent="#accordion">
                                        <button className={`border-0 bg-tr mx-3 clear-btn px-0 ${tokenDate.startDate ? "" : 'd-none'} `} onClick={() => {
                                            setTokenDate({})
                                        }}
                                        >
                                            Clear All
                                        </button>
                                        <div className="d-flex justify-content-between align-center mx-3" >
                                            <div className='mr-8 mb-20 w-100'>
                                                <Form.Label>
                                                    Start Date
                                                </Form.Label>
                                                <DatePicker
                                                    selected={tokenDate.startDate ? new Date(tokenDate.startDate) : ''}
                                                    placeholderText={'Start Date'}
                                                    maxDate={new Date()}
                                                    onChange={(date) => handleTokenDateChange('startDate', date)}
                                                    dateFormat="dd MMM yyyy"
                                                    className={`form-control text-input`}
                                                />
                                            </div>
                                            <div className='w-100'>
                                                <Form.Label>
                                                    End Date
                                                </Form.Label>
                                                <DatePicker
                                                    selected={tokenDate.endDate ? new Date(tokenDate.endDate) : ''}
                                                    placeholderText={'End Date'}
                                                    // maxDate={new Date()}
                                                    minDate={tokenDate.startDate}
                                                    onChange={(date) => handleTokenDateChange('endDate', date)}
                                                    dateFormat="dd MMM yyyy"
                                                    className={`form-control text-input`}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="filter-card cursor-pointer">
                                    <div className="filter-header collapsed" data-toggle="collapse" data-target="#bookingDate" aria-expanded="false" aria-controls="bookingDate" id="headingBooking">
                                        <div className="d-flex flex-row align-items-center justify-content-between">
                                            <h2 className="fz16 black mb-0 fw-regular">
                                                Booking Date
                                                {Object.keys(bookingDate).length > 0 && <span>{Object.keys(bookingDate).length}</span>}
                                            </h2>
                                            <div className="icon mr-0"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                <path fillRule="evenodd" clipRule="evenodd" d="M12 13.5858L16.2929 9.29289C16.6834 8.90237 17.3166 8.90237 17.7071 9.29289C18.0976 9.68342 18.0976 10.3166 17.7071 10.7071L12.7071 15.7071C12.3166 16.0976 11.6834 16.0976 11.2929 15.7071L6.29289 10.7071C5.90237 10.3166 5.90237 9.68342 6.29289 9.29289C6.68342 8.90237 7.31658 8.90237 7.70711 9.29289L12 13.5858Z" fill="#92929D" />
                                            </svg></div>
                                        </div>
                                    </div>
                                    <div id="bookingDate" className="filter-body collapse" aria-labelledby="headingBooking" data-parent="#accordion">
                                        <button className={`border-0 bg-tr mx-3 clear-btn px-0 ${bookingDate.startDate ? "" : 'd-none'} `} onClick={() => {
                                            setBookingDate({})
                                        }}
                                        >
                                            Clear All
                                        </button>
                                        <div className="d-flex justify-content-between align-center mx-3" >
                                            <div className='mr-8 mb-20 w-100'>
                                                <Form.Label>
                                                    Start Date
                                                </Form.Label>
                                                <DatePicker
                                                    selected={bookingDate.startDate ? new Date(bookingDate.startDate) : ''}
                                                    placeholderText={'Start Date'}
                                                    // maxDate={new Date()}
                                                    onChange={(date) => handleBookingDateChange('startDate', date)}
                                                    dateFormat="dd MMM yyyy"
                                                    className={`form-control text-input`}
                                                />
                                            </div>
                                            <div className='w-100'>
                                                <Form.Label>
                                                    End Date
                                                </Form.Label>
                                                <DatePicker
                                                    selected={bookingDate.endDate ? new Date(bookingDate.endDate) : ''}
                                                    placeholderText={'End Date'}
                                                    // maxDate={new Date()}
                                                    minDate={bookingDate.startDate}
                                                    onChange={(date) => handleBookingDateChange('endDate', date)}
                                                    dateFormat="dd MMM yyyy"
                                                    className={`form-control text-input`}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="form-inline justify-content-between px-20 filter-ok-cancel">
                        <button className="cancel outline-btn" onClick={() => setShow(false)}>Cancel</button>
                        <button className="pr-btn" onClick={sendFilterRequest}>Apply Filter</button>
                    </div>
                </>
            }
        />
    )
}